import { PREMIUM_FEATURES } from "@common/flatRateBilling";
import { useAllowFeature } from "./useAllowFeature";
import { useTypedFlags } from "./useTypedFlags";

/**
 * Gates the "Recognition schedule" columns in views: the `schedules` flag plus
 * the SCHEDULES premium feature. Reports enabled while billing is still
 * loading so cached views keep the column until the plan is known.
 */
export function useIsRecognitionScheduleColumnEnabled(): boolean {
    const { schedules: isSchedulesFlagEnabled } = useTypedFlags();
    const { hasAccess, isFetched } = useAllowFeature(
        PREMIUM_FEATURES.SCHEDULES,
    );

    return Boolean(isSchedulesFlagEnabled) && (!isFetched || hasAccess);
}
